import { showToastMessage } from "./Helper";

export class ToastMessages {
    static thereWasAnError(){
        showToastMessage("error", "There was an error during the process!");
    }
}